import { gql } from '@apollo/client';

export const EXPORT_INPUTS = gql`
  query ExportInputs($input: ExportArgs!) {
    inputs: exportInputs(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          type {
            id
            name
          }
          utilizationTracking
          frequencyType {
            id
            name
          }
          category {
            id
            name
          }
          description
          quantity
          overallTime
          treatmentTime
          budgetedAmount
          receivedAmount
          frequency {
            id
            name
          }
          frequencyInt
          distributed
          retrieved
          activity {
            id
            name
            interventions {
              id
              programme {
                id
              }
              serviceProviders {
                id
              }
            }
          }
          intervention {
            id
            name
            fromDate
            toDate
            gradeValues
            focusSubjectNames
            budgetedAmount
            spentAmount
            treatmentTime
            overallTime
            receivedAmount
            activities {
              id
              name
            }
            programme {
              id
              name
            }
            subjects {
              id
              name
            }
            serviceProviders {
              id
              name
            }
          }
        }
      }
    }
  }
`;
